export default {
    majors(state) {
        return state.majors;
    },
    getMajorById: (state, getters) => (majorId) => {
        const majors = getters.majors;
        const filtMjr = majors.find((m) => m.id == majorId);
        return filtMjr;
    },
};